import AccessibilityButton from './Buttons/AccessibilityButton';
import BackButton from './Buttons/BackButton';
import CloseButton from './Buttons/CloseButton';
import ForFamiliesButton from './Buttons/ForFamiliesButton';
import FamilyResourcesButton from './Buttons/FamilyResourcesButton';
import HomeButton from './Buttons/HomeButton';
import LogoutButton from './Buttons/LogoutButton';
import MatmanHelperButton from './Buttons/MatmanHelperButton';
import MatmanActivityButton from './Buttons/MatmanActivityButton';
import RewardsButton from './Buttons/RewardsButton';
import { ButtonTypes } from 'types';
import { ButtonProps } from './Buttons/Button';
import type { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-student';

export type ButtonsWrapperProps = ButtonProps & {
  name: string;
  from?: RouteSource;
};

const ButtonsWrapper: React.FC<ButtonsWrapperProps> = (props) => {
  // mocked data
  const featureToggles = [
    {
      enabled: false,
      name: ButtonTypes.ACCESSIBILITY_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.BACK_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.CLOSE_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.FAMILY_RESOURCES_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.FOR_FAMILIES_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.HOME_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.MAT_MAN_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.MAT_MAN_ACTIVITY_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.LOGOUT_BUTTON,
    },
    {
      enabled: true,
      name: ButtonTypes.REWARD_BUTTON,
    },
  ];
  const ButtonsList = {
    [ButtonTypes.ACCESSIBILITY_BUTTON]: <AccessibilityButton {...props} />,
    [ButtonTypes.BACK_BUTTON]: <BackButton {...props} />,
    [ButtonTypes.CLOSE_BUTTON]: <CloseButton {...props} />,
    [ButtonTypes.FAMILY_RESOURCES_BUTTON]: <FamilyResourcesButton {...props} />,
    [ButtonTypes.FOR_FAMILIES_BUTTON]: <ForFamiliesButton {...props} />,
    [ButtonTypes.HOME_BUTTON]: <HomeButton {...props} />,
    [ButtonTypes.LOGOUT_BUTTON]: <LogoutButton {...props} />,
    [ButtonTypes.MAT_MAN_BUTTON]: <MatmanHelperButton {...props} />,
    [ButtonTypes.MAT_MAN_ACTIVITY_BUTTON]: <MatmanActivityButton {...props} />,
    [ButtonTypes.REWARD_BUTTON]: <RewardsButton {...props} />,
  };
  const buttonConfig = featureToggles.find((each) => each.name === props.name);
  const buttonEnabled = buttonConfig?.enabled;
  if (props.name && buttonEnabled) {
    return ButtonsList[props.name];
  }
  return <></>;
};

export default ButtonsWrapper;
